import { render, staticRenderFns } from "./AppointmentByRoomReport.vue?vue&type=template&id=bfdb1ba8"
import script from "./AppointmentByRoomReport.vue?vue&type=script&lang=js"
export * from "./AppointmentByRoomReport.vue?vue&type=script&lang=js"
import style0 from "./AppointmentByRoomReport.vue?vue&type=style&index=0&id=bfdb1ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports